module.exports = __webpack_public_path__ + "img/youtube_1@4x.59cd1eaf.png";